import React from "react";
import styled from "styled-components";
import { InputField1 } from "../../../InputField1/InputField1";
import Typography from "../../../Typography/Typography";
import { MdCancelPresentation } from "react-icons/md";

const ImageChooser = ({ number, file, handleDelete, handleChange }) => {
  const handleChangeImage = (e) => {
    const { value, name } = e.target;

    if (name === "file") handleChange(file.id, e.target.files[0], name);
    else handleChange(file.id, value, name);
  };

  return (
    <ImageChooserStyle>
      <div className="title">
        <Typography>عکس {number}</Typography>
        <MdCancelPresentation
          size={"25px"}
          style={{ cursor: "pointer" }}
          onClick={(e) => handleDelete(file.id)}
        />
      </div>
      <div className="get-file">
        <InputField1
          type="file"
          name="file"
          onChange={handleChangeImage}
          maxLenght="50"
        />
        <InputField1
          type="text"
          placeholder={"altبه فارسی"}
          label={"alt"}
          name="alt"
          value={file?.alt}
          onChange={handleChangeImage}
          maxLenght="50"
        />
      </div>
    </ImageChooserStyle>
  );
};

function AddImage({ childPhoto, NewProduct, setChildPhoto }) {
  const addChildPhoto = (e) => {
    setChildPhoto([
      ...childPhoto,
      {
        file: "",
        alt: NewProduct?.nameProduct + "_" + (childPhoto?.length + 1),
        id: childPhoto.length + 1,
      },
    ]);
  };

  const handleDelete = (id) => {
    setChildPhoto(childPhoto?.filter((data) => data.id !== id));
  };

  const handleChange = (id, newValue, name) => {
    setChildPhoto(
      childPhoto?.map((data) => {
        if (data.id === id) return { ...data, [name]: newValue };
        return data;
      })
    );
  };

  return (
    <AddImageStyle>
      <WrapperImageStyle>
        {childPhoto?.map((data, index) => {
          return (
            <ImageChooser
              number={index + 1}
              handleDelete={handleDelete}
              handleChange={handleChange}
              key={index}
              file={data}
            />
          );
        })}
        <button className="add-child-btn" onClick={addChildPhoto}>
          افزودن عکس
        </button>
      </WrapperImageStyle>
    </AddImageStyle>
  );
}

const AddImageStyle = styled.div`
  background-color: ${({ theme }) => theme.backgroundSidebar};
`;

const WrapperImageStyle = styled.div`
  background-color: ${({ theme }) => theme.backgroundSidebar};
  padding: 1rem;
  display: flex;
  flex-direction: column;

  /* text */
  .add-child-btn {
    padding: 0.8rem 1.5rem;
    outline: none;
    margin: 0 auto;
    border: none;
    border-radius: 0.5rem;
    width: 200px;
    color: #fff;
    background: #009ef7;
  }
`;

const ImageChooserStyle = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  padding: 1rem;
  row-gap: 0.5rem;

  .title {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }

  .get-file {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    row-gap: 0.5rem;
  }
`;

export default AddImage;
